export const UrlLinks = {
  customerLocationLinks: '/zoekklantlocatiekoppelingen',
} as const

export const LboCookie = {
  cookieName: 'lbo-vestiging',
  cookieMaxAge: 300000000,
  cookiePath: '/',
} as const

export const LocationLinkCookie = {
  cookieName: 'lbo-klantlocatiekoppeling-vestiging',
  cookieMaxAge: 300000000,
  cookiePath: UrlLinks.customerLocationLinks, //alleen toegankelijk voor '/zoekklantlocatiekoppelingen' en alles daarna.
} as const
